// Responsive section wrapper with consistent vertical rhythm.
// Mobile ~64px, tablet ~80px, desktop ~112–128px vertical padding.
export default function Section({ id, bg = "bg", className = "", children, tight = false }) {
  const bgc = bg === "surface" ? "bg-rp-surface border-y border-white/10" : "bg-rp-bg";
  const pad = tight ? "py-14 md:py-20" : "py-16 sm:py-20 md:py-28 lg:py-32";
  return (
    <section id={id} className={`${bgc} ${id ? "scroll-mt-24" : ""} ${className}`}>
      <div className={`mx-auto max-w-7xl px-6 md:px-12 ${pad}`}>{children}</div>
    </section>
  );
}
